import React from "react";
import TagBadge, { tagBadgeColor, tagName } from "./TagBadge";
import { Button } from "@mantine/core";

const PeopleTags = ({ tags = [], selectedTagId, onSelect, language }) => {
  if (!tags.length) {
    return null;
  }

  return (
    <div className="flex justify-center flex-wrap items-center gap-1">
      {tags.map((tag) => {
        const isSelected = tag.id === selectedTagId;

        return (
          <Button
            key={tag.id}
            type="button"
            variant="subtle"
            size="sm"
            className="p-0"
            onClick={() => onSelect(tag)}
            onMouseDown={() => onSelect(tag)}
          >
            <TagBadge
              component="span"
              radius="md"
              size="md"
              className="cursor-pointer"
              color={tagBadgeColor(tag.name, tag.type)}
              variant="filled"
              style={isSelected
                ? { transform: 'scale(1.08)', boxShadow: '0 0 0 2px var(--mantine-color-body), 0 0 0 4px var(--mantine-color-text)', transition: 'transform 0.15s, box-shadow 0.15s' }
                : { transition: 'transform 0.15s' }}
            >
              <div className="flex items-center text-center gap-1">
                {tag.imgUrl && (
                  <img
                    className="w-5 max-w-none h-5 rounded-full"
                    src={tag.imgUrl}
                    alt={tag.name}
                  />
                )}
                <span>{tagName(tag.name, language)}</span>
              </div>
            </TagBadge>
          </Button>
        );
      })}
    </div>
  );
};

export default PeopleTags;
